define('cartware/components/_base',[
	"cartware/components/Logger",
	"cartware/components/PubSubHub"
], function(
	Logger,
	PubSubHub
) {

	return {
		create: function(properties) {
			var constructor = null;

			if ("constructor" in properties) {
				constructor = properties.constructor;
				delete properties.constructor;
			}

			function Component() {
				if (null !== constructor) {
					constructor.apply(this, arguments);
				}
			}

			if (!("logger" in properties)) {
				properties.logger = Logger;
			}

			if (!("hub" in properties)) {
				properties.hub = PubSubHub;
			}

			Component.prototype = properties;

			return Component;
		}
	}

});
